export const SOURCING_EXTERNAL_YEARS_IN_CURRENT_ROLE = [
  {
    label: '0-2',
    value: '0_2'
  },
  {
    label: '2-4',
    value: '2_4'
  },
  {
    label: '4-6',
    value: '4_6'
  },
  {
    label: '6-8',
    value: '6_8'
  },
  {
    label: '8-10',
    value: '8_10'
  },
  {
    label: '10+',
    value: '10'
  }
] as const;
